module.exports = __webpack_public_path__ + "static/media/product_brot.2beccc53.png";